import React, { Component } from 'react';

import Routes from './router';
import './splashApp.css';

class App extends Component {
  render() {
    return (
      <Routes />
    );
  }
}

export default App;
